import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../library/button/button';
import GhostButton from '../../../../library/ghost-button/ghost-button';
import Select from '../../../../library/select/select';
import Typography from '../../../../library/typography/typography';
import CanonicalFormOption from '../canonical-form-option/canonical-form-option';

import './canonical-form-field.scss';

function CanonicalFormField(props) {
  const {
    hasButtonOptions,
    hideInfoButton,
    hideWhatIsThisLabel = false,
    label,
    onChange,
    onOpenModal,
    options,
    optionSuffix,
    selectedValue,
    showSingleOptionValues
  } = props;

  return options?.length > 1 ? (
    <div>
      {hasButtonOptions ? (
        <>
          <div styleName="what-label">
            {!hideWhatIsThisLabel && (
              <Typography styleName="label" tag="span">
                {label}:
              </Typography>
            )}
            {onOpenModal && (
              <Button onClick={onOpenModal} type="button">
                what is this?
              </Button>
            )}
          </div>

          <div styleName="button-group">
            {options.map((value, idx) => (
              <GhostButton
                isSelected={selectedValue?.value === value.value}
                isUnavailable={value.shouldResetFilter}
                key={`il-${idx}`}
                onClick={() => onChange(value)}
              >
                {value.value}
              </GhostButton>
            ))}
          </div>
        </>
      ) : (
        <>
          <Select
            hideResetButton
            isRequired
            label={label}
            onChange={onChange}
            options={options}
            renderOption={props => (
              <CanonicalFormOption {...props} suffix={optionSuffix} />
            )}
            renderValue={props => (
              <CanonicalFormOption {...props} suffix={optionSuffix} />
            )}
            value={selectedValue}
          />
          {!hideInfoButton && onOpenModal && (
            <Button onClick={onOpenModal} styleName="info-button" type="button">
              what is {label?.toLowerCase()}?
            </Button>
          )}
        </>
      )}
    </div>
  ) : (
    <>
      {showSingleOptionValues && selectedValue && options?.length > 0 && (
        <div>
          <div styleName="what-label">
            {!hideWhatIsThisLabel && (
              <Typography styleName="label" tag="span">
                {label}:
              </Typography>
            )}
            {onOpenModal && (
              <Button onClick={onOpenModal} type="button">
                what is this?
              </Button>
            )}
          </div>
          <strong>{selectedValue?.value}</strong>
        </div>
      )}
    </>
  );
}

CanonicalFormField.propTypes = {
  hasButtonOptions: PropTypes.bool,
  hideInfoButton: PropTypes.bool,
  hideWhatIsThisLabel: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onOpenModal: PropTypes.func,
  optionSuffix: PropTypes.string,
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  showSingleOptionValues: PropTypes.bool
};

export default CanonicalFormField;
